import { Col, Container, Row } from 'react-bootstrap';
import { Link } from "react-router-dom";
import HomeImg from '../../../Assets/HomePage/home1.png';
import './Banner.css';

const Banner = () => {
    return (
            <section className="hero-bg text-white d-flex justify-content-center align-items-center">
                <Container>
                    <Row className="">
                        <Col md={12} sm={12} lg={6} className='mt-5'>
                            <div className="hero-slide-left justify-content-end align-items-center text-center text-lg-start">
                                <h2>Improving Lives Through</h2>
                                <h1>Enhanced Mobility and Wellness</h1>
                                <p className="mb-xs-5">Step into a welcoming world of physiotherapy where our dedicated professionals are committed to restoring your vitality. We're here to put the spring back in your step!</p>
                                <div className="banner-btn m-sm-auto">
                                    <Link to="/appoinment"><button className="theme-btn theme-btn-2 btn-fill">Get Appoinment</button></Link>
                                    <Link to='/contact'><button className='theme-btn bth-blank'>Get in Touch</button></Link>
                                </div>
                            </div>
                        </Col>
                        <Col md={12} sm={12} lg={5} className="">
                            <div className="hero-slide-right text-center text-lg-start mt-sm-5">
                                <img src={HomeImg} alt="" className="physio"/>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
    );
};

export default Banner;